var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdxAudioPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.404297,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FCEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2019_14923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1865 10.7793V22.0293C22.1865 22.3277 22.068 22.6138 21.857 22.8248C21.646 23.0358 21.3599 23.1543 21.0615 23.1543H18.249C17.9507 23.1543 17.6645 23.0358 17.4535 22.8248C17.2425 22.6138 17.124 22.3277 17.124 22.0293V10.7793C17.124 10.4809 17.2425 10.1948 17.4535 9.9838C17.6645 9.77282 17.9507 9.6543 18.249 9.6543H21.0615C21.3599 9.6543 21.646 9.77282 21.857 9.9838C22.068 10.1948 22.1865 10.4809 22.1865 10.7793ZM13.749 9.6543H10.9365C10.6382 9.6543 10.352 9.77282 10.141 9.9838C9.93005 10.1948 9.81152 10.4809 9.81152 10.7793V22.0293C9.81152 22.3277 9.93005 22.6138 10.141 22.8248C10.352 23.0358 10.6382 23.1543 10.9365 23.1543H13.749C14.0474 23.1543 14.3335 23.0358 14.5445 22.8248C14.7555 22.6138 14.874 22.3277 14.874 22.0293V10.7793C14.874 10.4809 14.7555 10.1948 14.5445 9.9838C14.3335 9.77282 14.0474 9.6543 13.749 9.6543Z",
    fill: "#FC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2019_14923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7.4043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxAudioPause);
export default __webpack_public_path__ + "static/media/ddx-audio-pause.16c11c8511079f1ea5f5cefefd12c545.svg";
export { ForwardRef as ReactComponent };